import lazyWithPreload from 'utils/lazyPreload';

const BulkStudentSelectDrawer = lazyWithPreload(
  () => import('./containers/Drawer'),
);

export const BULK_STUDENT_SELECT_DRAWER = 'BULK_STUDENT_SELECT_DRAWER';

export default {
  [BULK_STUDENT_SELECT_DRAWER]: BulkStudentSelectDrawer,
};
